import React, { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

const Success = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const sessionId = query.get('session_id');

    if (sessionId) {
      verifyPayment(sessionId);
    }
  }, []);

  const verifyPayment = async (sessionId) => {
    const functions = getFunctions();
    const confirmSubscription = httpsCallable(functions, 'confirmSubscription');

    try {
      const { data } = await confirmSubscription({ sessionId });
      setSubscription(data.subscription);
      setMessage('Payment successful!');
    } catch (error) {
      setMessage('Error verifying payment. Please contact support.');
      console.error('Error verifying payment:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>{message}</h1>
      {subscription && (
        <div>
          <p>Subscription ID: {subscription.id}</p>
          <p>Subscription Status: {subscription.status}</p>
        </div>
      )}
    </div>
  );
};

export default Success;